import Link from 'next/link'

import { Poster } from '@/app/components/atoms/Poster'

import styles from './RecintoRelatedVenues.module.scss'

interface RecintoRelatedVenueCardProps {
  readonly title: string
  readonly href: string
  readonly img: string | null
  readonly location: string
}

/**
 * `RecintoRelatedVenueCard` — tarjeta de recinto relacionado: imagen a
 * sangre con un overlay de degradado SIEMPRE visible (nombre + ciudad), sin
 * fecha ni precio (un recinto no los tiene). Paridad visual con la card
 * `cardVariant="product"` de `shared/CoverCarousel` de `eci-firefly-uikit`
 * cuando sus ítems son recintos (`VenueNearby`/`nearbyVenues`, sin `date`/
 * `price`), reimplementada con tokens y clases propias del proyecto
 * (Constitución, "Migración: reimplementar, no copiar") — mismo criterio ya
 * aplicado por `ProductPosterCard` (módulo CMS «Productos») para la variante
 * con evento.
 *
 * Toda la tarjeta es un único enlace hacia `href`; el overlay se marca
 * `aria-hidden` porque el nombre accesible del enlace ya incluye nombre y
 * ciudad, así que no se anuncia dos veces.
 *
 * Server Component: presentación pura, sin estado ni efectos.
 */
export function RecintoRelatedVenueCard({ title, href, img, location }: RecintoRelatedVenueCardProps) {
  const accessibleLabel = [title, location].filter(Boolean).join(' — ')

  return (
    <Link href={href} className={styles.card} aria-label={accessibleLabel}>
      <div className={styles.imageWrap}>
        {img && <Poster src={img} alt="" className={styles.poster} />}

        <div className={styles.overlay} aria-hidden="true">
          <p className={styles.cardTitle}>{title}</p>
          {location && <p className={styles.cardLocation}>{location}</p>}
        </div>
      </div>
    </Link>
  )
}
